import { createRoutine, bindRoutineToReduxForm } from "redux-saga-routines";
import formName from "./formName";

export const submitFormRoutine = createRoutine(`SUBMIT_${formName}_FORM`);
export const submitFormHandler = bindRoutineToReduxForm(submitFormRoutine);
